export const mapFormData = (customerData, formData) => {
  const finalData = { ...formData };

  finalData.profiles = formData.profiles.map((profile) => {
    const customerProfile = customerData.find(
      (data) => data.type === profile.data[0].type
    );
    if (!customerProfile) return profile;

    const fieldsGrouped = [];
    const fieldsData = customerProfile.fields.reduce((groups, field, index) => {
      const groupIndex = Math.floor(index / profile.data[0].fields[0].length);
      groups[groupIndex] = groups[groupIndex] || [];
      groups[groupIndex].push(field);
      return groups;
    }, []);

    fieldsGrouped.push(
      ...fieldsData.map((group) =>
        group.map((field, idx) => ({
          name: field.name,
          value:
            field.fieldType === "select"
              ? { value: field.value, label: field.value }
              : field.value,
          type: field.fieldType,
          required: profile.data[0].fields[0][idx]?.required || false,
          span: profile.data[0].fields[0][idx]?.span || 1,
        }))
      )
    );

    return {
      ...profile,
      data: [
        {
          ...profile.data[0],
          fields: fieldsGrouped,
        },
      ],
    };
  });

  return finalData;
};
